module.exports = __webpack_public_path__ + "static/media/picto_cocktail.0000d01b.png";